import { render, staticRenderFns } from "./transform-modal.vue?vue&type=template&id=c405a560&scoped=true"
import script from "./transform-modal.vue?vue&type=script&lang=js"
export * from "./transform-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c405a560",
  null
  
)

export default component.exports